import { render, staticRenderFns } from "./RasioUpload.vue?vue&type=template&id=6652f162&scoped=true"
import script from "./RasioUpload.vue?vue&type=script&lang=js"
export * from "./RasioUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6652f162",
  null
  
)

export default component.exports